<template>
	<div>
		<div class="company-banner">
			<img src="https://img.bosszhipin.com/beijin/mcs/bar/20191216/8bd3460249238711b566a3577c5d2c69be1bd4a3bd2a63f070bdbdada9aad826.jpg?x-oss-process=image/resize,w_120,limit_0"
				alt="中联重科LOGO" class="fl">
			<h1>
				中联重科
			</h1>
			<div class="cate-save">
				<el-button size="small" type="success" @click="handleEdit(-1)" plain>修改信息</el-button>
			</div>
		</div>
		<div class="company-info-box">
			<div class="job-sec">
				<h3>公司简介</h3>
				<div class="fold-text">中联重科土方机械公司</div>
			</div>
			<div class="job-sec company-business">
				<h3>工商信息</h3>
				<div class="business-detail">
					<ul>
						<li class="business-detail-name"><span class="t">企业名称：</span>中联重科股份有限公司</li>
						<li class="business-detail-user"><span class="t">法定代表人：</span>詹纯新</li>
						<li class="business-detail-type"><span class="t">企业类型：</span>其他股份有限公司（上市）</li>
						<li class="business-detail-id"><span class="t">统一社会信用代码：</span>914300007121944054</li>
					</ul>
				</div>
			</div>
		</div>
		<el-dialog :title="title" :visible.sync="editFormVisible" @click='closeDialog("edit")'>
			<div class="dialog-footer">
				<el-button size="small" @click='closeDialog("edit")'>取消</el-button>
				<el-button size="small" type="primary" class="title" @click="saveTheWork('editForm')">保存</el-button>
			</div>
			<el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
				<el-form-item label="公司简介"  prop="deptName">
					<el-input size="small" type="textarea" v-model="editForm.deptName" auto-complete="off" placeholder="请输入工作名" />
				</el-form-item>
				<el-form-item label="企业类型" prop="wtypes">
					<el-select size="small" v-model="editForm.wtypes" placeholder="请选择" class="userRole">
						<el-option v-for="(item,index) in wtypes" :hidden="index==0" :label="item" :value="index" />
					</el-select>
				</el-form-item>
				<el-form-item  label="工作主图" prop="urls">
					<div class="main-block">
						<el-upload multiple action="#" :before-upload="(file) => {return beforeUpload_zhutu(file)}"
							accept=".png,.jpg,.gif" :multiple="false">
							<a class="iconfont icon-addimg add-img-icon" />
							<el-image class="main-img" v-for="iem in editForm.zimg" fit="contain" :src="iem.url"
								alt="" />
						</el-upload>
						<a class="iconfont icon-clean clean-img-icon" @click="deleteTheImg(1)" />
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>

</template>
<script>
	import {
		GetTheRecruiting,
		uploadFile,
		SubmitAddNewWorks,
		GetTheWorkInfo,
		OnlineTheWork,
		deleteImg
	} from '../../api/userMG'
	import {
		PictureServer
	} from "../../api/api"
	export default {
		data() {
			return {
				theindex: 0,
				listData: [],
				cInfo: JSON.parse(localStorage.getItem('userInfo')),
				numtype: ['仅限个人', '仅限团队', '不限'],
				wtypes: ['', '长期工作', '短期工作', '设计项目', '线下实习', '限定任务', '信息补充'],
				state: ['未上线', '暂无报名', '已有报名', '工作中', '结束', '停止'],
				editFormVisible: false,
				editForm: {
					deptName: '',
					numtype: '',
					wtypes: '',
					price: '',
					phone: '',
					skill: '',
					des: '',
					urls: '',
					zimg: [],
					ximg: []
				},
				imgh: PictureServer.Info,
				znums: 0,
				xnums: 0,
				rules: {
					deptName: [{
						required: true,
						message: '请输入工作名',
						trigger: 'blur'
					}],
					numtype: [{
						required: true,
						message: '请选择报名方式',
						trigger: 'blur'
					}],
					wtypes: [{
						required: true,
						message: '请选择工作类型',
						trigger: 'blur'
					}],
					price: [{
						required: true,
						message: '请输入工作价格',
						trigger: 'blur'
					}],
					phone: [{
							required: true,
							message: '请输入负责人手机号',
							trigger: 'blur'
						},
						{
							pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
							required: true,
							message: '请输入正确的手机号',
							trigger: 'blur'
						}
					],
					des: [{
						required: true,
						message: '请描述项目具体内容',
						trigger: 'blur'
					}]
				},
			}
		},
		created() {
			GetTheRecruiting(0).then(res => {
				console.log(res.data)
				var goodss = [],
					ynum
				for (var j = 0; j < res.length; j++) {
					goodss.push({
						deptName: res[j][1],
						deptId: res[j][0],
						price: res[j][3],
						wtypes: res[j][2],
						numtype: res[j][4],
					})
				}
				this.listData = goodss
			})
		},
		methods: {
			//添加或编辑工作
			handleEdit: function() {
					this.title = '编辑信息'
					this.theindex = index
					this.editFormVisible = true
					GetTheWorkInfo(this.listData[index].deptId).then(res => {
						this.editForm.deptName = this.listData[index].deptName
						this.editForm.numtype = this.listData[index].numtype
						this.editForm.wtypes = this.listData[index].wtypes
						this.editForm.price = this.listData[index].price
						this.editForm.phone = res[4]
						this.editForm.des = res[0]
						this.editForm.urls = res[2]
						this.editForm.skill = res[1]
						this.editForm.zimg = []
						this.znums = 0
						this.editForm.ximg = []
						this.xnums = 0
						if (res[3]) {
							var imgss = res[3].split(",")
							for (var k = 0; k < imgss[0]; k++) {
								this.editForm.zimg.push({
									url: PictureServer.Info + 'stuwork_' + this.listData[index]
										.deptId + '_m_' + k +
										'.png'
								})
							}
							this.znums = k
							for (var k = 0; k < imgss[1]; k++) {
								this.editForm.ximg.push({
									url: PictureServer.Info + 'stuwork_' + this.listData[index]
										.deptId + '_d_' + k +
										'.png'
								})
							}
							this.xnums = k
						}
					})
				
			},
			// 关闭编辑、增加弹出框
			closeDialog() {
				this.editFormVisible = false
			},
			beforeUpload_zhutu(file) {
				var filen = 'stuwork_' + this.listData[this.theindex].deptId + '_m_' + this.znums + '.png'
				this.znums++
				setTimeout(r => {
					uploadFile(file, filen).then(res => {
						this.editForm.zimg.push({
							url: PictureServer.Info + filen + '?rnd=' + Math.random()
						})
					})
					return false;
				}, this.znums * 200)
			},
			beforeUpload_xiangqin(file) {
				var filen = 'stuwork_' + this.listData[this.theindex].deptId + '_d_' + this.xnums + '.png'
				this.xnums++
				setTimeout(r => {
					uploadFile(file, filen).then(res => {
						this.editForm.ximg.push({
							url: PictureServer.Info + filen + '?rnd=' + Math.random()
						})
					})
					return false;
				}, this.xnums * 200)
			},
			add_cate(index) {
				this.$confirm('将上线该工作，若有人提交报名将无法修改，且您审核报名通过后将无法删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					OnlineTheWork(this.listData[index].deptId).then(res => {
						if (res) {
							this.listData.splice(index, 1)
							that.$message.success('工作已上线');
						}
					})
				})
			},
			saveTheWork(editData) {
				this.$refs[editData].validate(valid => {
					console.log(valid)
					if (valid) {
						if (this.theindex == -1) {
							this.$confirm('确定新建工作?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								SubmitAddNewWorks({
									n: this.editForm.deptName,
									nt: this.editForm.numtype,
									wt: this.editForm.wtypes,
									pr: this.editForm.price,
									p: this.editForm.phone,
									d: this.editForm.des,
									sk: this.editForm.skill,
									u: this.editForm.urls
								}).then(res => {
									if (res) {
										this.listData.push({
											deptId: res,
											ynum: [
												[0, 0], 0
											],
											deptName: this.editForm.deptName,
											price: this.editForm.price,
											wtypes: this.editForm.wtypes,
											numtype: this.editForm.numtype,
											state: 0
										})
										this.$message.success('新键工作成功，请尽快编辑补充描述图片')
										this.editFormVisible = false
									}
								})
							})
						} else {
							this.$confirm('确定修改工作内容?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								SubmitAddNewWorks({
									id: this.listData[this.theindex].deptId,
									n: this.editForm.deptName,
									nt: this.editForm.numtype,
									wt: this.editForm.wtypes,
									pr: this.editForm.price,
									p: this.editForm.phone,
									d: this.editForm.des,
									sk: this.editForm.skill,
									u: this.editForm.urls,
									i: this.editForm.zimg.length + ',' + this.editForm.ximg.length
								}).then(res => {
									if (res) {
										this.listData[this.theindex].deptName = this.editForm
											.deptName
										this.listData[this.theindex].price = this.editForm.price
										this.listData[this.theindex].wtypes = this.editForm.wtypes
										this.listData[this.theindex].numtype = this.editForm
											.numtype
										this.$message.success('修改成功')
										this.editFormVisible = false
									}
								})
							})
						}
					}
				})
			},
			deleteTheImg(t) {
				this.$confirm('确定删除图片吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (t) {
						for (var k = 0; k < this.editForm.zimg.length; k++) {
							deleteImg('stuwork_' + this.listData[this.theindex].deptId + '_m_' + k + '.png')
						}
						this.editForm.zimg = []
						this.znums = 0
						this.$message.success('该工作主图已全部删除');
					} else {
						for (var k = 0; k < this.editForm.ximg.length; k++) {
							deleteImg('stuwork_' + this.listData[this.theindex].deptId + '_d_' + k + '.png')
						}
						this.xnums = 0
						this.editForm.ximg = []
						this.$message.success('该工作详情图已全部删除');
					}
				})
			}
		}
	}
</script>

<style scoped>
	.company-banner {
		background-image: linear-gradient(90deg, #3b526a 0, #345a6d 100%);
		padding: 40px 0 30px 0;
		line-height: 0;
		display: flex;
		border-radius: 12px;
		position: relative;
	}

	.company-banner img {
		width: 80px;
		height: 80px;
		border-radius: 12px;
		margin-left: 30px;
	}

	.company-banner h1 {
		font-size: 28px;
		font-weight: 600;
		color: #fff;
		line-height: 40px;
		margin-left: 30px;
	}
	.cate-save{
		position: absolute;
		top: 20px;
		right: 20px;
	}
	.company-info-box {
		background: #fff;
		border-radius: 12px;
		padding: 20px 30px;
	}

	.company-info-box .job-sec h3 {
		font-size: 18px;
		font-weight: 600;
		color: #222;
		line-height: 25px;
		margin-bottom: 12px;
		padding: 0;
	}

	.company-info-box .fold-text {
		font-size: 15px;
		font-weight: 400;
		color: #333;
		line-height: 28px;
		max-height: 113px;
		overflow: hidden;
	}

	.company-business .business-detail {
		position: relative;
		border-radius: 12px;
		border: none;
		background: #f8f8f8;
		padding: 20px;
		height: auto;
	}

	.company-business .business-detail {
		position: relative;
		border-radius: 12px;
		border: none;
		background: #f8f8f8;
		padding: 20px;
		height: auto;
	    display: grid;
	}

	.company-business .business-detail li {
		font-size: 15px;
		color: #333;
		line-height: 21px;
		padding: 0 5px 0 0;
		margin-bottom: 30px;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		-ms-box-sizing: border-box;
		-o-box-sizing: border-box;
		box-sizing: border-box;
		width: 50%;
		float: left;
	}

	.company-business .business-detail li span {
		display: block;
		font-size: 14px;
		color: #999;
		line-height: 20px;
		margin-bottom: 8px;
	}

	.userRole {
		width: 100%;
	}

	.dialog-footer {
		position: absolute;
		top: 25px;
		right: 20%;
	}

	.main-block {
		width: 100%;
		border: 1px solid black;
		display: inline-block;
	}

	.main-img {
		width: 100px;

	}

	.clean-img-icon {
		float: right;
		margin: 0 10px 10px 0;
		font-size: 30px;
	}
</style>


// WEBPACK FOOTER //
// src/views/company/infoSet.vue